import { isRouteErrorResponse, useRouteError } from 'react-router';

import { ErrorPage } from './error-page.component';
import { NotFound } from './not-found.component';

/**
 * The tasks app's route error boundary. A 404 gets the branded not-found page;
 * any other error gets the branded error page. In dev the caught Error is passed
 * through so its message + stack stay visible for debugging.
 */
export function ErrorBoundary() {
	const error = useRouteError();

	if (isRouteErrorResponse(error) && error.status === 404) {
		return <NotFound />;
	}

	const devError = import.meta.env.DEV && error instanceof Error ? error : undefined;
	return <ErrorPage error={devError} />;
}
